import { render, staticRenderFns } from "./sso_config.vue?vue&type=template&id=11905206&scoped=true&"
import script from "./sso_config.vue?vue&type=script&lang=js&"
export * from "./sso_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11905206",
  null
  
)

export default component.exports